import React, { RefObject } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToY } from 'utils/scroll';
import { getFilters } from 'redux/modules/recipes/get-filtered-recipes';
import useQueryParams from '../../utils/use-queryparams';
import Filters, { Filter, CheckedState } from './Filters';

const paramIsFilter = (key: string) => key.endsWith('_flt');

const QueryParamFilters = ({
  filters = [],
  isFiltersModalOpen,
  toggleModal,
}: {
  filters: Filter[];
  isFiltersModalOpen: boolean;
  toggleModal: () => void;
}) => {
  const location = useLocation();
  const [, setQueryParams] = useQueryParams();
  const activeFilters = getFilters(new URLSearchParams(location.search)).reduce((acc, v) => {
    acc[v.title] = v.values;
    return acc;
  }, {});

  const checked = filters.reduce<CheckedState>(
    (acc, filter, i) => {
      if (activeFilters[filter.title]) {
        filter.values.forEach((v, j) => {
          if (activeFilters[filter.title].includes(v.name)) {
            acc[i][j] = true;
          }
        });
      }
      return acc;
    },
    Array.from({ length: filters.length }, () => []),
  );

  return (
    <Filters
      filters={filters}
      externalState={checked}
      isFiltersModalOpen={isFiltersModalOpen}
      toggleModal={toggleModal}
      onChange={(checkedState: CheckedState) => {
        const search = new URLSearchParams(location.search);

        const toRemove: Array<string> = [];
        search.forEach((_, key) => {
          if (paramIsFilter(key)) toRemove.push(key);
        });
        toRemove.forEach(key => search.delete(key));

        filters.forEach(({ title, values }, f) => {
          const items = values.filter((_, i) => checkedState[f][i]);
          if (items.length) {
            search.set(`${title}_flt`, items.map(v => v.name).toString());
          }
        });

        search.delete('page');

        setQueryParams(
          Array.from(search.keys()).reduce<Record<string, string>>((acc, key) => {
            acc[key] = search.get(key)!; // eslint-disable-line @typescript-eslint/no-non-null-assertion
            return acc;
          }, {}),
        );
      }}
      // @ts-expect-error untyped component
      onClose={(ref: RefObject<HTMLDivElement | null>) => {
        setTimeout(() => {
          if (!ref.current) return;

          const { top } = ref.current.getBoundingClientRect();
          scrollToY(top + window.scrollY - 80);
        }, 0);
      }}
    />
  );
};

export default QueryParamFilters;
export const { propTypes } = Filters; // eslint-disable-line react/forbid-foreign-prop-types
